var React = require('react');

function IconSuccessCircleO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M951.7 509.5c0-245.8-199.2-445-445-445s-445 199.2-445 445 199.2 445 445 445 445-199.2 445-445zm-826 0c0-210.4 170.6-381 381-381s381 170.6 381 381-170.6 381-381 381-381-170.6-381-381z","key":0}),React.createElement("path",{"d":"M475.3 686.8L289.5 536.6c-1.8-1.4-2-4.1-.4-5.8l47.3-52c1.4-1.6 3.8-1.8 5.5-.4l129 104.5L683.4 331c1.4-1.7 3.9-1.9 5.6-.5l56.4 46.3c1.7 1.4 2 4 .5 5.7l-265 303.8c-1.5 1.6-3.9 1.8-5.6.5z","key":1})]);
}

IconSuccessCircleO.displayName = "IconSuccessCircleO";

IconSuccessCircleO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconSuccessCircleO;

IconSuccessCircleO.default = IconSuccessCircleO;
